/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context";

import Grid from "@mui/material/Grid";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// Anaytics dashboard components
import SalesByCountry from "layouts/dashboards/analytics/components/SalesByCountry";

import crudsService from "services/cruds-service";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import DefaultDoughnutChart from "examples/Charts/DoughnutCharts/DefaultDoughnutChart";
import GroupBy from "helper/group-by";
import MDDatePicker from "components/MDDatePicker";
import { Card } from "@mui/material";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/NewDataTable";
import FilterForm from "./components/filter";
// import DataTable from "examples/Tables/DataTable";

function CountryAnalytics() {
  const { setIsAuthenticated, getCurrentUser } = useContext(AuthContext);
  const [countryChartData, setCountryChartData] = useState();
  const [countrytableData, setCountryTabledata] = useState({});
  const [txnResultChartData, setTxnResultChartData] = useState();

  useEffect(() => {
    async function checkToken() {
      let user = await getCurrentUser();
      if (!user) {
        setIsAuthenticated(false);
        localStorage.removeItem("token");
      }
    }
    checkToken();
  }, []);

  const prebareChartObj = (arr, labelTxt, dataTxt, getMonthName = false) => {
    let labels = [];
    let data = [];
    for (const key in arr) {
      if (Object.prototype.hasOwnProperty.call(arr, key)) {
        const element = arr[key];
        let label;
        if (getMonthName) {
          label = getMonthNameInArabic(element[labelTxt]);
        } else {
          label = element[labelTxt];
        }
        labels.push(label);
        data.push(element.sum[dataTxt]);
      }
    }

    return { labels, data };
  };

  const prebareTableObj = (arr) => {
    const groupedArr = GroupBy(arr, "country");
    let rows = [];
    let suc;
    let fil;
    for (let key in groupedArr) {
      if (Object.hasOwn(groupedArr, key)) {
        suc = groupedArr[key].filter((f) => f.TxnResult === "Success")[0];
        fil = groupedArr[key].filter((f) => f.TxnResult === "Failed")[0];
        rows.push({
          country: key,
          countFil: (fil?.count.id || 0) + "",
          countSuc: (suc?.count.id || 0) + "",
          valFil: (fil?.sum.PurchAmount || 0) + "",
          valSuc: (suc?.sum.PurchAmount || 0) + "",
        });
      }
    }
    let columns = [
      { accessor: "country", Header: "البلد", width: "25%" },
      {
        accessor: "countSuc",
        Header: "عدد العمليات الناجحة",
        width: "30%",
      },
      { accessor: "valSuc", Header: "قيمة العمليات الناجحة" },
      {
        accessor: "countFil",
        Header: "عدد العمليات الفاشلة",
        width: "12%",
      },
      { accessor: "valFil", Header: "قيمة العمليات الفاشلة", width: "12%" },
    ];
    return { columns, rows };
  };

  async function getProjects(f = "") {
    //country tabel data
    const donationCountryTableData = await crudsService.donationCharts(
      "country,TxnResult",
      f
    );

    setCountryTabledata(
      prebareTableObj(donationCountryTableData.data, "country", "PurchAmount")
    );

    const donationCountryChartsData = await crudsService.donationCharts(
      "country",
      `filter[ProcReturnCode][_eq]=00${f ? `&${f}` : ""}`
    );

    setCountryChartData(
      prebareChartObj(donationCountryChartsData.data, "country", "PurchAmount")
    );

    const donationTxnResultChartsData = await crudsService.donationCharts(
      "TxnResult",
      f
    );

    setTxnResultChartData(
      prebareChartObj(
        donationTxnResultChartsData.data,
        "TxnResult",
        "PurchAmount"
      )
    );
  }

  useEffect(() => {
    getProjects();
  }, []);

  return (
    <DashboardLayout>
      <MDBox py={3}>
        <FilterForm getProjects={getProjects} />

        <Grid container>
          <SalesByCountry
            data={countrytableData}
            title="التبرعات على البلد"
            color="success"
          />
        </Grid>
        <Grid container spacing={3} pt={5}>
          <Grid item xs={12} md={6} lg={4}>
            {txnResultChartData && (
              <DefaultDoughnutChart
                icon={{ color: "success", component: "signposticon" }}
                title="حالة التبرعات"
                description=""
                chart={{
                  labels: txnResultChartData.labels,
                  datasets: {
                    label: "التبرعات",
                    backgroundColors: [
                      "error",
                      "success",
                      "info",
                      "dark",
                      "secondary",
                      "primary",
                      "warning",
                    ],
                    data: txnResultChartData.data,
                  },
                }}
              />
            )}
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            {countryChartData && (
              <DefaultLineChart
                icon={{ color: "success", component: "mapicon" }}
                title="التبرعات مع البلاد"
                description=""
                chart={{
                  labels: countryChartData.labels,
                  datasets: [
                    {
                      label: "التبرعات",
                      color: "success",
                      data: countryChartData.data,
                    },
                  ],
                }}
              />
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CountryAnalytics;
